<script>
  import ContactProperties from '$lib/contacts/Properties.svelte';
  import viewport from '@/js/utils/useViewportAction.js';
  export let info;

  const icons = {
    email: 'message-edit',
    phone: 'call',
    address: 'location',
    social: 'link',
  };

  let grow = false;
</script>

<section
  class="info-wrap"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <div class="container">
    {#if info.items && info.items.length}
      <div class="flexbox info">
        {#each info.items as infoItem}
          <div class="col col-25 col-m-50 col-s-full">
            <div class="contact-item">
              <i
                class={`contact-item__icon isax isax-${icons[infoItem.type]}`}
              />
              <h2 class="h6 contact-item__title">{infoItem.title}</h2>
              {#if infoItem.address}
                <p class="contact-item__address text-small">
                  {infoItem.address}
                </p>
              {/if}

              {#if infoItem.items && infoItem.items.length}
                <div class="contact-item__content">
                  {#each infoItem.items as item}
                    {#if item.title}
                      <p class="text-small">
                        {item.title}
                      </p>
                    {/if}
                    <p>
                      <a
                        class="text-link"
                        href={item.url}
                        target={['address', 'social'].includes(infoItem.type)
                          ? '_blank'
                          : '_self'}
                        rel={['address', 'social'].includes(infoItem.type)
                          ? 'noreferrer'
                          : ''}><span>{item.value}</span></a
                      >
                    </p>
                  {/each}
                </div>
              {/if}
            </div>
            <div class="line-vertical" />
            <div class="line-horizontal" />
          </div>
        {/each}
      </div>
    {/if}

    {#if info.properties}
      <ContactProperties properties={info.properties} />
    {/if}
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .info-wrap {
    @include resp-max('s') {
      padding-top: 0;
    }
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }
  }
  .info {
    row-gap: 3rem;

    @include resp-min('s') {
      row-gap: 5rem;
    }

    .col {
      position: relative;

      &:nth-child(4) > .line-vertical {
        display: none;
      }

      &:nth-child(4) > .line-horizontal {
        display: none;
      }

      @include resp-max('m') {
        &:nth-child(2) > .line-vertical {
          display: none;
        }
      }
    }

    .line-vertical {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;

      @include resp-max('s') {
        display: none;
      }
    }

    .line-horizontal {
      margin: 3rem auto 0;
      max-width: 24rem;

      @include resp-min('s') {
        display: none;
      }
    }
  }

  .contact-item {
    text-align: center;

    &__icon {
      font-size: 2.8rem;
    }

    &__title {
      margin-top: 1rem;
    }

    &__address {
      margin-top: 2rem;
    }

    &__content {
      margin-top: 2rem;

      p {
        margin-bottom: 1.4rem;
      }
    }
  }
</style>
